export const MIXPANEL_API_KEY = "bea472807561c219804c0832b4e98ad7";
// export const CLIENT_ID = "61013745975-qihjbfohuloigdnigc0h8dedohde0ijd.apps.googleusercontent.com"
export const CLIENT_ID = "822000143398-crp1770e81sotbt60hv8v1eobhfal5oc.apps.googleusercontent.com"
export const SCOPES = "https://www.googleapis.com/auth/analytics.readonly";
export const GOOGLE_ACCOUNT_SUMMARIES =
"https://analyticsadmin.googleapis.com/v1alpha/accountSummaries";
